<script setup lang="ts">
import NotificationBadge, { type NotificationType } from './NotificationBadge.vue';

defineProps<{
  type: NotificationType;
  title: string;
  description: string;
  time: string;
  isRead: boolean;
  to?: string;
}>();
</script>

<template>
  <component
    :is="to ? 'RouterLink' : 'div'"
    :to="to"
    class="flex gap-3 items-start px-4 py-4"
    :class="to ? 'transition hover:bg-brown-50 cursor-pointer' : ''"
  >
    <NotificationBadge :type="type" />
    <div class="flex flex-col gap-2 flex-1 min-w-0">
      <strong class="font-roboto-slab text-sm text-brown-600">{{ title }}</strong>
      <p class="font-montserrat text-xs text-brown-600 leading-base font-medium">{{ description }}</p>
      <div class="flex gap-1.5 items-center">
        <div v-if="!isRead" class="size-1 rounded-full bg-red-500 shrink-0 mt-0.5" />
        <span class="font-roboto-slab font-bold text-xs text-brown-600 whitespace-nowrap">{{ time }}</span>
      </div>
    </div>
  </component>
</template>
